module.exports = __webpack_public_path__ + "img/ai_icon2.7d1858f8.png";